module.exports = __webpack_public_path__ + "4bea847ef0bc59498a47570cdbe6ca3e.png";